import { BsTrash3 } from 'react-icons/bs'

import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IInAppFeature } from '~/types/iap'

import './styles.scss'

const DeleteActionCellRenderer = ({ context, data }: ICellRendererParams<IInAppFeature>): ReactElement => {
  if (!data) return <div />

  const { feature } = data

  const { handleDeleteFeatureClick } = context as { handleDeleteFeatureClick: (featureId: string) => void }

  const onDeleteClick = () => handleDeleteFeatureClick(feature.feature_id)

  return (
    <div className="delete-action-cell-renderer" onClick={onDeleteClick}>
      <BsTrash3 color="#ca3423" size={18} />
    </div>
  )
}

export default DeleteActionCellRenderer
